import { Injectable } from '@angular/core';
import {ConnectionsDialogComponent} from './connections-dialog.component';
import {NodeApiService} from '../../../services/api/network/online/node/node-api.service';
import {RoutingInterfaceApiService} from '../../../services/api/network/online/routing-interface/routing-interface-api.service';
import {MatDialog} from '@angular/material/dialog';
import {ConnectionApiService} from '../../../services/api/network/online/connection/connection-api.service';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {forkJoin} from 'rxjs';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {LogicalConjunctionService} from '../../../services/common/logical-conjunction/logical-conjunction.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectionDialogService {

  constructor(public dialog: MatDialog,
              private nodeApiService: NodeApiService,
              private snackBarService: SnackBarService,
              private connectionApiService: ConnectionApiService,
              private logicalConjunctionService: LogicalConjunctionService,
              private routingInterfaceApiService: RoutingInterfaceApiService) { }

  readonly addEditDialogWidth = '700px';

  edit(selection, nodes, routingInterface, ipProfiles, mediaRealm, advancedConditions, onSuccess = () => {}): void {
    forkJoin({
      srcNode: this.nodeApiService.getNode(selection.connections[0].srcNodeId),
      destNode: this.nodeApiService.getNode(selection.connections[0].destNodeId),
      srcRI: this.routingInterfaceApiService.getRoutingInterface(selection.connections[0].srcRoutingInterface),
      destRI: this.routingInterfaceApiService.getRoutingInterface(selection.connections[0].destRoutingInterface)
    }).subscribe(data => {

      const dialogRef = this.dialog.open(ConnectionsDialogComponent, {
        width: this.addEditDialogWidth,
        data: {
          isEditMode: true,
          selectedItem: selection,
          nodes, routingInterface, ipProfiles,
          mediaRealm, advancedConditions,
          srcNode: data.srcNode,
          destNode: data.destNode,
          srcRI: data.srcRI,
          destRI: data.destRI,
          srcNodeEdge: selection.connections[0] ? selection.connections[0] : {},
          destNodeEdge: selection.connections[1] ? selection.connections[1] : {},
        }
      });

      dialogRef.componentInstance.onApply.subscribe(connection => {
        this.connectionApiService.editConnection(connection, selection.id).then(() => {
          this.snackBarService.display(`"${connection.name}" successfully edited`);
          onSuccess();
          dialogRef.close();
        }).catch(() => {});
      });
    });
  }

  add(connection, nodes, routingInterface, ipProfiles, mediaRealm, advancedConditions, onSuccess = () => {}, onCancel = () => {}): void {
    connection.weight = 50;

    const dialogRef = this.dialog.open(ConnectionsDialogComponent, {
      width: this.addEditDialogWidth,
      data: {
        isEditMode: false,
        selectedItem: connection,
        nodes,
        routingInterface,
        ipProfiles,
        mediaRealm,
        advancedConditions
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.connectionApiService.addConnection(result).then(() => {
        this.snackBarService.display(`"${result.name}" successfully added`);
        onSuccess();
        dialogRef.close();
      });
    });

    dialogRef.componentInstance.onCancel.subscribe( () => {
      onCancel();
    });
  }

  delete(selection, onSuccess = () => {}): void {
    const ids = selection.map(connection => connection.id);

    const confirmationMessage = `Are you sure you want to delete ${ids.length === 1 ?
      `the connection: "${selection[0].name}"` :
      `${ids.length} connections: ${this.logicalConjunctionService
        .generateAndDescription(selection, 'name')}`} ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.connectionApiService.deleteConnections(selection.map(selectionItem => selectionItem.id)).then(() => {
        dialogRef.close();
        this.snackBarService.display(`${this.logicalConjunctionService
          .generateAndDescription(selection, 'name')} successfully deleted`);
        onSuccess();
      });
    });
  }
}
